import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getStorage} from 'firebase/storage';
import { getFirestore } from "firebase/firestore"


const firebaseConfig = {
  apiKey: "AIzaSyA7weLi-yqC95aLefgeptGF4w6joWsNzds",
  authDomain: "elevate-5a47e.firebaseapp.com",
  projectId: "elevate-5a47e",
  storageBucket: "elevate-5a47e.firebasestorage.app",
  messagingSenderId: "596923159537",
  appId: "1:596923159537:web:14f104c90e9fe9cb5d2a50",
  measurementId: "G-0TMZ6NZ5B3"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const db = getFirestore(app);


export const storage = getStorage(app)

export { app, auth, db, firebaseConfig };
